  (function () {
    'use strict';

    const ACTION_DEFINITIONS = [
      {
        name: '@toggle_platform_on_current_root',
        aliases: ['toggle_platform_on_current_root'],
        execute: executeTogglePlatformOnCurrentRoot,
      },
      {
        name: '@toggle_platform_on_currrent_component',
        aliases: ['toggle_platform_on_currrent_component', '@toggle_platform_on_current_component', 'toggle_platform_on_current_component'],
        execute: executeTogglePlatformOnCurrentComponent,
      },
      {
        name: '@toggle_platform_marquis',
        aliases: ['toggle_platform_marquis'],
        execute: executeTogglePlatformMarquis,
      },
      {
        name: '@sync_dimmer_base_plate',
        aliases: ['sync_dimmer_base_plate'],
        execute: executeSyncDimmerBasePlate,
      },
      {
        name: '@sync_isolation_top_to_drawer_face',
        aliases: ['sync_isolation_top_to_drawer_face'],
        execute: executeSyncIsolationTopToDrawerFace,
      },
      {
        name: '@sync_saenger_drawer_boxes',
        aliases: ['sync_saenger_drawer_boxes'],
        execute: executeSyncSaengerDrawerBoxes,
      },
      { name: '@apply_to_all_slots', aliases: ['apply_to_all_slots'], execute: executeApplyToAllSlots },
      {
        name: '@keep_component',
        aliases: ['keep_component'],
        execute: executeKeepComponent,
      },
      {
        name: '@keep_mid_century_height',
        aliases: ['keep_mid_century_height'],
        execute: executeKeepMidCenturyHeight,
      },
    ];

    const ACTIONS_BY_ALIAS = buildActionAliasMap(ACTION_DEFINITIONS);

    function buildActionAliasMap(definitions) {
      const aliasMap = new Map();

      definitions.forEach((definition) => {
        const aliases = [definition.name].concat(Array.isArray(definition.aliases) ? definition.aliases : []);

        aliases.forEach((alias) => {
          const normalizedAlias = normalizeAlias(alias);
          if (!normalizedAlias) return;
          aliasMap.set(normalizedAlias, definition);
        });
      });

      return aliasMap;
    }

    function normalizeAlias(value) {
      return typeof value === 'string' ? value.trim().toLowerCase() : '';
    }

    function getActionDefinition(actionName) {
      const normalizedActionName = normalizeAlias(actionName);
      if (!normalizedActionName) return null;
      return ACTIONS_BY_ALIAS.get(normalizedActionName) || null;
    }

    function normalizeAction(actionName) {
      const actionDefinition = getActionDefinition(actionName);
      return actionDefinition ? actionDefinition.name : '';
    }

    function createActionContext(payload) {
      const normalizedPayload = payload && typeof payload === 'object' ? payload : {};
      const helpers = normalizedPayload.helpers || {};
      const latestSlots = Array.isArray(normalizedPayload.latestSlots) ? normalizedPayload.latestSlots : [];

      return {
        rule: normalizedPayload.rule || null,
        eventContext: normalizedPayload.context || null,
        helpers,
        latestSlots,
        getSelectedOptionLabel(optionLabel) {
          return getSelectedMwOptionValueLabel(optionLabel, helpers);
        },
        findActiveSlotByLabel(slotLabel) {
          return findActiveSlotByLabel(slotLabel, latestSlots, helpers);
        },
        findActiveSlotForOption(optionLabel) {
          return findActiveSlotForOption(optionLabel, latestSlots, helpers);
        },
        findMaterialInSlot(slot, materialLabel) {
          if (!slot) return null;

          const normalizedMaterialLabel = helpers.normalizeEntityName(materialLabel);
          if (!normalizedMaterialLabel) return null;

          return helpers.findMaterialByName(slot, normalizedMaterialLabel);
        },
        applyMaterialToActiveSlot(slotLabel, materialLabel) {
          const targetSlot = findActiveSlotByLabel(slotLabel, latestSlots, helpers);
          if (!targetSlot) {
            console.warn('[Metabox-MW] Custom action slot not found in active context', {
              slotName: slotLabel,
              context: normalizedPayload.context || null,
              actionName: normalizedPayload.rule && normalizedPayload.rule.componentAction,
            });
            return false;
          }

          const material = this.findMaterialInSlot(targetSlot, materialLabel);
          if (!material) {
            console.warn('[Metabox-MW] Custom action material not found in active context', {
              slotName: slotLabel,
              materialName: materialLabel,
              context: normalizedPayload.context || null,
              actionName: normalizedPayload.rule && normalizedPayload.rule.componentAction,
            });
            return false;
          }

          if (!(window.metaboxConfigurator && window.metaboxConfigurator.changeMaterial)) {
            console.error('[Metabox-MW] changeMaterial API not available');
            return false;
          }

          return window.metaboxConfigurator.changeMaterial(targetSlot.id, material.id);
        },
        applyMaterialToActiveOption(optionLabel, materialLabel) {
          const targetSlot = findActiveSlotForOption(optionLabel, latestSlots, helpers);
          if (!targetSlot) {
            console.warn('[Metabox-MW] Custom action option slot not found in active context', {
              optionLabel,
              materialName: materialLabel,
              context: normalizedPayload.context || null,
              actionName: normalizedPayload.rule && normalizedPayload.rule.componentAction,
            });
            return false;
          }

          const material = this.findMaterialInSlot(targetSlot, materialLabel);
          if (!material) {
            console.warn('[Metabox-MW] Custom action material not found in active option slot', {
              optionLabel,
              slotName: targetSlot.label || targetSlot.id || null,
              materialName: materialLabel,
              context: normalizedPayload.context || null,
              actionName: normalizedPayload.rule && normalizedPayload.rule.componentAction,
            });
            return false;
          }

          if (!(window.metaboxConfigurator && window.metaboxConfigurator.changeMaterial)) {
            console.error('[Metabox-MW] changeMaterial API not available');
            return false;
          }

          return window.metaboxConfigurator.changeMaterial(targetSlot.id, material.id);
        },
      };
    }

    function findMwOptionByLabel(optionLabel, helpers) {
      const container = document.querySelector('.mw-apo-container');
      if (!container) return null;

      const normalizedOptionLabel = helpers.normalizeOptionName(optionLabel);
      if (!normalizedOptionLabel) return null;

      const options = Array.from(container.querySelectorAll('.mw-option'));
      return (
        options.find((option) => {
          const labelElement = option.querySelector('.mw-text.mw-text--style-strong');
          const labelText = labelElement && labelElement.textContent ? labelElement.textContent.trim() : '';
          return helpers.normalizeOptionName(labelText) === normalizedOptionLabel;
        }) || null
      );
    }

    function getSelectedMwOptionValueLabel(optionLabel, helpers) {
      const option = findMwOptionByLabel(optionLabel, helpers);
      if (!option) return '';

      const values = Array.from(option.querySelectorAll('.mw-option__value'));
      if (!values.length) return '';

      const selectedIndex = values.findIndex((value) => {
        const input = value.querySelector('input.mw-option__control');
        return Boolean(input && input.checked);
      });
      if (selectedIndex >= 0) {
        return helpers.asString(helpers.getMwValueLabel(values[selectedIndex], selectedIndex));
      }

      const activeValue =
        option.querySelector('.mw-option__value.is-selected') ||
        option.querySelector('.mw-option__value.selected') ||
        option.querySelector('.mw-option__value.mw-option__value--selected');

      if (!activeValue) return '';

      const activeIndex = values.indexOf(activeValue);
      return helpers.asString(helpers.getMwValueLabel(activeValue, activeIndex >= 0 ? activeIndex : 0));
    }

    function findActiveSlotByLabel(slotLabel, latestSlots, helpers) {
      const allSlots = Array.isArray(latestSlots) ? latestSlots : [];
      const normalizedSlotLabel = helpers.normalizeEntityName(slotLabel);
      if (!normalizedSlotLabel) return null;

      const activeSlots = helpers.filterSlotsByActiveComponents(allSlots);
      return (
        helpers.findSlotByNameFromSlots(activeSlots, normalizedSlotLabel) ||
        helpers.findSlotByNameFromSlots(allSlots, normalizedSlotLabel) ||
        null
      );
    }

    function findActiveSlotForOption(optionLabel, latestSlots, helpers) {
      const allSlots = Array.isArray(latestSlots) ? latestSlots : [];
      const activeSlots = helpers.filterSlotsByActiveComponents(allSlots);

      return (
        helpers.findMatchingSlot(activeSlots, optionLabel) ||
        helpers.findMatchingSlot(allSlots, optionLabel) ||
        null
      );
    }

    function getCurrentActiveSlotMaterialLabel(slot, helpers) {
      if (!slot || !helpers) return '';

      const envelope = window.__lastMetaboxEnvelope;
      const configurationTree = Array.isArray(envelope && envelope.configurationTree) ? envelope.configurationTree : [];
      const rootNode = configurationTree.find((node) => node && !node.parentId);
      const componentMaterialIds = envelope && envelope.componentMaterialsIds;
      const activeComponentMaterials =
        rootNode && componentMaterialIds && typeof componentMaterialIds === 'object' ? componentMaterialIds[rootNode.id] : null;
      const activeMaterialId = activeComponentMaterials && slot.id ? activeComponentMaterials[slot.id] : null;
      const enabledMaterials = Array.isArray(slot.enabledMaterials) ? slot.enabledMaterials : [];

      if (!activeMaterialId || !enabledMaterials.length) return '';

      const material =
        enabledMaterials.find((candidate) => candidate && candidate.id === activeMaterialId) || null;
      return material ? helpers.asString(helpers.getMaterialLabel(material, enabledMaterials.indexOf(material))) : '';
    }

    function executeApplyToAllSlots(actionContext) {
      const optionLabel = actionContext.rule && actionContext.rule.optionLabelRaw;
      const slotLabel = actionContext.rule && actionContext.rule.slotNameRaw;
      const selectedValueLabel = actionContext.getSelectedOptionLabel(optionLabel);
      const slotNameNorm = actionContext.helpers.normalizeEntityName(slotLabel);
      const selectedValueNorm = actionContext.helpers.normalizeMaterialLookupName(selectedValueLabel);
      const getSlotComponentId = (slot) => {
        if (!slot || typeof slot !== 'object') return null;
        if (slot.componentId) return slot.componentId;
        if (typeof slot.id !== 'string') return null;
        const separatorIndex = slot.id.indexOf('::');
        return separatorIndex > 0 ? slot.id.slice(0, separatorIndex) : null;
      };
      const getComponentDisplayName = (component) =>
        (component && component.name) ||
        (component && component.title) ||
        (component && component.product && component.product.title) ||
        (component && component.componentType && component.componentType.name) ||
        '';
      const getDecorVariant = (component) => {
        const normalizedName = actionContext.helpers.normalizeEntityName(getComponentDisplayName(component));
        if (!normalizedName) return null;
        if (normalizedName.includes('nodecor') || normalizedName.includes('no decor')) return 'nodecor';
        if (normalizedName.includes('decor')) return 'decor';
        return null;
      };
      const getDecorPairingKey = (component) =>
        actionContext.helpers
          .normalizeEntityName(getComponentDisplayName(component))
          .replace(/\bnodecor\b/g, ' ')
          .replace(/\bno decor\b/g, ' ')
          .replace(/\bdecor\b/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

      if (!optionLabel || !slotLabel) {
        console.warn('[Metabox-MW] Apply to all slots action requires option/slot', {
          componentAction: actionContext.rule && actionContext.rule.componentAction,
          optionLabel: optionLabel || null,
          slotName: slotLabel || null,
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      if (!selectedValueLabel) {
        console.warn('[Metabox-MW] Apply to all slots skipped: selected MW value missing', {
          optionLabel,
          slotName: slotLabel,
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      const findMatchingSlots = (slots) => {
        if (!Array.isArray(slots) || !slotNameNorm) return [];

        const exactMatches = slots.filter((slot) => {
          const labelNorm = actionContext.helpers.normalizeEntityName(slot && slot.label);
          const idNorm = actionContext.helpers.normalizeEntityName(slot && slot.id);
          return labelNorm === slotNameNorm || idNorm === slotNameNorm;
        });
        if (exactMatches.length) return exactMatches;

        return slots.filter((slot) => {
          const labelNorm = actionContext.helpers.normalizeEntityName(slot && slot.label);
          const idNorm = actionContext.helpers.normalizeEntityName(slot && slot.id);
          return (
            (labelNorm && (labelNorm.includes(slotNameNorm) || slotNameNorm.includes(labelNorm))) ||
            (idNorm && (idNorm.includes(slotNameNorm) || slotNameNorm.includes(idNorm)))
          );
        });
      };

      const allSlots = Array.isArray(actionContext.latestSlots) ? actionContext.latestSlots : [];
      const activeSlots = actionContext.helpers.filterSlotsByActiveComponents(allSlots);
      const activeMatchingSlots = findMatchingSlots(activeSlots);
      const baseTargetSlots = activeMatchingSlots.length ? activeMatchingSlots : findMatchingSlots(allSlots);
      const components = actionContext.helpers.getConfiguratorComponents();
      const componentsById = new Map(components.map((component) => [component && component.id, component]));
      const targetSlotsById = new Map(baseTargetSlots.map((slot) => [slot && slot.id, slot]));

      baseTargetSlots.forEach((slot) => {
        const componentId = getSlotComponentId(slot);
        const component = componentsById.get(componentId);
        const componentTypeId = component && component.componentType && component.componentType.id;
        const pairingKey = getDecorPairingKey(component);
        if (!componentTypeId || !pairingKey || !getDecorVariant(component)) return;

        components.forEach((candidate) => {
          if (!candidate || candidate.id === componentId) return;
          if ((candidate.componentType && candidate.componentType.id) !== componentTypeId) return;
          if (getDecorPairingKey(candidate) !== pairingKey) return;
          if (!getDecorVariant(candidate)) return;

          const candidateSlots = findMatchingSlots(allSlots.filter((candidateSlot) => getSlotComponentId(candidateSlot) === candidate.id));
          candidateSlots.forEach((candidateSlot) => {
            if (!candidateSlot || !candidateSlot.id) return;
            targetSlotsById.set(candidateSlot.id, candidateSlot);
          });
        });
      });

      const targetSlots = Array.from(targetSlotsById.values());
      if (!targetSlots.length) {
        console.warn('[Metabox-MW] Apply to all slots skipped: no matching slots found', {
          optionLabel,
          slotName: slotLabel,
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      if (!(window.metaboxConfigurator && window.metaboxConfigurator.changeMaterial)) {
        console.error('[Metabox-MW] changeMaterial API not available');
        return { handled: true, success: false };
      }

      let changedAll = true;

      targetSlots.forEach((slot) => {
        const materials = Array.isArray(slot && slot.enabledMaterials) ? slot.enabledMaterials : [];
        const material = materials.find((candidate, index) => {
          const materialLabel = actionContext.helpers.getMaterialLabel(candidate, index);
          return actionContext.helpers.normalizeMaterialLookupName(materialLabel) === selectedValueNorm;
        }) || null;
        if (!material) {
          changedAll = false;
          console.warn('[Metabox-MW] Apply to all slots skipped: material not found in slot', {
            optionLabel,
            slotName: slotLabel,
            selectedValueLabel,
            slotId: slot && slot.id ? slot.id : null,
            context: actionContext.eventContext,
          });
          return;
        }

        const changed = window.metaboxConfigurator.changeMaterial(slot.id, material.id);
        if (!changed) {
          changedAll = false;
        }
      });

      return { handled: true, success: changedAll };
    }

    function executeTogglePlatformOnCurrentRoot(actionContext) {
      const activeRoot = actionContext.helpers.getActiveRootComponent();
      if (!activeRoot) {
        console.warn('[Metabox-MW] Platform toggle target not found: missing active root', {
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      const activeDescriptor = actionContext.helpers.getRootVariantDescriptor(activeRoot);
      if (!activeDescriptor) {
        console.warn('[Metabox-MW] Platform toggle target not found: missing root descriptor', {
          activeRoot: actionContext.helpers.getPreferredComponentName(activeRoot),
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      const desiredPlatformState = Boolean(actionContext.rule && actionContext.rule.whenSelected);
      if (activeDescriptor.platformEnabled === desiredPlatformState) {
        return { handled: true, component: activeRoot };
      }

      const targetComponent =
        actionContext.helpers.getRootComponents().find((component) => {
          const candidateDescriptor = actionContext.helpers.getRootVariantDescriptor(component);
          if (!candidateDescriptor) return false;

          return (
            candidateDescriptor.familyKey === activeDescriptor.familyKey &&
            candidateDescriptor.layout === activeDescriptor.layout &&
            candidateDescriptor.platformEnabled === desiredPlatformState
          );
        }) || null;

      if (!targetComponent) {
        const connectedComponentResult = executeTogglePlatformMarquis(actionContext);
        if (connectedComponentResult?.component || connectedComponentResult?.success !== false) {
          return connectedComponentResult;
        }
      }

      if (!targetComponent) {
        console.warn('[Metabox-MW] Platform toggle target not found for current root', {
          componentAction: actionContext.rule && actionContext.rule.componentAction,
          desiredPlatformState,
          activeRoot: actionContext.helpers.getPreferredComponentName(activeRoot),
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      return { handled: true, component: targetComponent };
    }

    function executeTogglePlatformOnCurrentComponent(actionContext) {
      const getComponentKey = (component) =>
        (component && component.name) ||
        (component && component.componentType && component.componentType.name) ||
        '';
      const normalizeComponentKey = (component) => actionContext.helpers.normalizeEntityName(getComponentKey(component));
      const normalizeFamilyKey = (value) =>
        String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/_platform_/g, '_')
          .replace(/_(decor|dec|nodecor)\b/g, '')
          .replace(/_bp\b/g, '')
          .replace(/^_+|_+$/g, '');
      const withPlatform = (componentKey) => {
        if (/_platform_/i.test(componentKey)) return componentKey;
        if (/_decor\b/i.test(componentKey)) return componentKey.replace(/_decor\b/i, '_platform_decor');
        if (/_nodecor\b/i.test(componentKey)) return componentKey.replace(/_nodecor\b/i, '_platform_nodecor');
        return `${componentKey}_platform`;
      };
      const withoutPlatform = (componentKey) => componentKey.replace(/_platform_/ig, '_');
      const activeRoot = actionContext.helpers.getActiveRootComponent();
      if (!activeRoot) {
        console.warn('[Metabox-MW] Platform component toggle target not found: missing active root', {
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      const rootConnectorIds = new Set(
        Array.isArray(activeRoot?.virtualSocketToConnectorsMap)
          ? activeRoot.virtualSocketToConnectorsMap.map((entry) => entry?.connectorId).filter(Boolean)
          : []
      );
      const activeComponentIds = new Set(actionContext.helpers.getActiveComponents().map((component) => component?.id).filter(Boolean));
      const connectedComponents = actionContext.helpers
        .getConfiguratorComponents()
        .filter((component) => {
          if (!component || component?.componentType?.isRoot) return false;
          if (!Array.isArray(component.virtualSocketToConnectorsMap)) return false;
          if (!component.virtualSocketToConnectorsMap.some((entry) => rootConnectorIds.has(entry?.connectorId))) return false;
          return true;
        });
      const activeConnectedComponent =
        connectedComponents.find((component) => {
          if (!activeComponentIds.has(component.id)) return false;
          return /(horizontal|solid|platform)/i.test(getComponentKey(component));
        }) || null;
      const targetFamilyKey = normalizeFamilyKey(
        activeConnectedComponent ? getComponentKey(activeConnectedComponent) : actionContext.helpers.getBaseModel()
      );
      const familyComponents = connectedComponents.filter(
        (component) => targetFamilyKey && normalizeFamilyKey(getComponentKey(component)) === targetFamilyKey
      );

      const activeComponent =
        activeConnectedComponent ||
        familyComponents.find((component) => !/_platform_/i.test(getComponentKey(component))) ||
        null;

      if (!activeComponent) {
        console.warn('[Metabox-MW] Platform component toggle target not found: missing active component', {
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      const activeComponentKey = getComponentKey(activeComponent);
      const desiredPlatformState = Boolean(actionContext.rule && actionContext.rule.whenSelected);
      const targetComponentKey = desiredPlatformState ? withPlatform(activeComponentKey) : withoutPlatform(activeComponentKey);

      if (targetComponentKey === activeComponentKey) {
        return { handled: true, component: activeComponent };
      }

      const targetComponent =
        familyComponents.find((component) => getComponentKey(component).toLowerCase() === targetComponentKey.toLowerCase()) || null;

      if (!targetComponent) {
        console.warn('[Metabox-MW] Platform component toggle target not found for active component', {
          componentAction: actionContext.rule && actionContext.rule.componentAction,
          desiredPlatformState,
          activeComponent: activeComponentKey,
          targetComponent: targetComponentKey,
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      return { handled: true, component: targetComponent };
    }

    function executeTogglePlatformMarquis(actionContext) {
      const getComponentKey = (component) =>
        (component && component.name) ||
        (component && component.componentType && component.componentType.name) ||
        '';
      const toComponentKeyTokens = (value) =>
        String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '')
          .replace(/_+/g, '_');
      const collapseComponentKey = (value) => toComponentKeyTokens(value).replace(/_/g, '');
      const getDecorVariant = (value) => {
        const tokenizedValue = toComponentKeyTokens(value);
        if (/(^|_)nodecor(?=_|$)/.test(tokenizedValue)) return 'nodecor';
        if (/(^|_)(decor|dec)(?=_|$)/.test(tokenizedValue)) return 'decor';
        return 'default';
      };
      const hasPlatformFamilyToken = (value) => {
        const tokenizedValue = toComponentKeyTokens(value);
        return /(^|_)(platform|noplatform|no_platform)(?=_|$)/.test(tokenizedValue);
      };
      const hasLayoutFamilyToken = (value) => {
        const tokenizedValue = toComponentKeyTokens(value);
        return /(^|_)(horizontal|solid|centered|center|offset)(?=_|$)/.test(tokenizedValue);
      };
      const isPlatformEnabled = (value) => {
        const tokenizedValue = toComponentKeyTokens(value);
        if (/(^|_)(noplatform|no_platform)(?=_|$)/.test(tokenizedValue)) return false;
        return /(^|_)platform(?=_|$)/.test(tokenizedValue);
      };
      const normalizeFamilyKey = (value) =>
        toComponentKeyTokens(value)
          .replace(/(^|_)(noplatform|no_platform)(?=_|$)/g, '_')
          .replace(/(^|_)platform(?=_|$)/g, '_')
          .replace(/(^|_)base(?=_|$)/g, '_')
          .replace(/(^|_)(decor|dec|nodecor)(?=_|$)/g, '_')
          .replace(/(^|_)bp(?=_|$)/g, '_')
          .replace(/^_+|_+$/g, '')
          .replace(/_+/g, '_');
      const withPlatform = (componentKey) => {
        if (/\bno[\s_]*platform\b/i.test(componentKey)) {
          return componentKey.replace(/\bno[\s_]*platform\b/i, (match) => (match.includes('_') ? 'platform' : 'Platform'));
        }
        if (/\bnoplatform\b/i.test(componentKey)) {
          return componentKey.replace(/\bnoplatform\b/i, 'platform');
        }
        if (/_platform_/i.test(componentKey)) return componentKey;
        if (/_platform\b/i.test(componentKey)) return componentKey;
        if (/\bplatform\b/i.test(componentKey)) return componentKey;
        if (/_base\b/i.test(componentKey)) return componentKey.replace(/_base\b/i, '_platform');
        if (/_decor\b/i.test(componentKey)) return componentKey.replace(/_decor\b/i, '_platform_decor');
        if (/_nodecor\b/i.test(componentKey)) return componentKey.replace(/_nodecor\b/i, '_platform_nodecor');
        return `${componentKey}_platform`;
      };
      const withoutPlatform = (componentKey) => {
        if (/\bno[\s_]*platform\b/i.test(componentKey) || /\bnoplatform\b/i.test(componentKey)) return componentKey;
        if (/_platform_/i.test(componentKey) || /_platform\b/i.test(componentKey)) {
          return componentKey.replace(/_platform(?=_|$)/ig, '_noplatform');
        }
        if (/\bplatform\b/i.test(componentKey)) {
          return componentKey.replace(/\bplatform\b/i, 'No Platform');
        }
        return componentKey;
      };
      const activeRoot = actionContext.helpers.getActiveRootComponent();
      if (!activeRoot) {
        console.warn('[Metabox-MW] Marquis platform toggle target not found: missing active root', {
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      const rootConnectorIds = new Set(
        Array.isArray(activeRoot?.virtualSocketToConnectorsMap)
          ? activeRoot.virtualSocketToConnectorsMap.map((entry) => entry?.connectorId).filter(Boolean)
          : []
      );
      const activeComponentIds = new Set(actionContext.helpers.getActiveComponents().map((component) => component?.id).filter(Boolean));
      const connectedComponents = actionContext.helpers
        .getConfiguratorComponents()
        .filter((component) => {
          if (!component || component?.componentType?.isRoot) return false;
          if (!Array.isArray(component.virtualSocketToConnectorsMap)) return false;
          if (!component.virtualSocketToConnectorsMap.some((entry) => rootConnectorIds.has(entry?.connectorId))) return false;
          return true;
        });
      const activeConnectedComponent =
        connectedComponents.find((component) => {
          if (!activeComponentIds.has(component.id)) return false;
          return hasLayoutFamilyToken(getComponentKey(component)) || hasPlatformFamilyToken(getComponentKey(component));
        }) || null;
      const targetFamilyKey = normalizeFamilyKey(
        activeConnectedComponent ? getComponentKey(activeConnectedComponent) : actionContext.helpers.getBaseModel()
      );
      const familyComponents = connectedComponents.filter(
        (component) =>
          targetFamilyKey &&
          hasPlatformFamilyToken(getComponentKey(component)) &&
          normalizeFamilyKey(getComponentKey(component)) === targetFamilyKey
      );

      const activeComponent =
        activeConnectedComponent ||
        familyComponents.find((component) => activeComponentIds.has(component.id)) ||
        familyComponents.find((component) => !isPlatformEnabled(getComponentKey(component))) ||
        familyComponents[0] ||
        null;

      if (!activeComponent) {
        console.warn('[Metabox-MW] Marquis platform toggle target not found: missing active component', {
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      const activeComponentKey = getComponentKey(activeComponent);
      const desiredPlatformState = Boolean(actionContext.rule && actionContext.rule.whenSelected);
      const targetComponentKey = desiredPlatformState ? withPlatform(activeComponentKey) : withoutPlatform(activeComponentKey);
      const targetComponentKeyCollapsed = collapseComponentKey(targetComponentKey);
      const activeDecorVariant = getDecorVariant(activeComponentKey);

      if (targetComponentKey === activeComponentKey) {
        return { handled: true, component: activeComponent };
      }

      const targetComponent =
        familyComponents.find((component) => getComponentKey(component).toLowerCase() === targetComponentKey.toLowerCase()) ||
        familyComponents.find((component) => collapseComponentKey(getComponentKey(component)) === targetComponentKeyCollapsed) ||
        familyComponents.find((component) => {
          const componentKey = getComponentKey(component);
          if (isPlatformEnabled(componentKey) !== desiredPlatformState) return false;
          if (activeDecorVariant === 'default') return getDecorVariant(componentKey) === 'default';
          return getDecorVariant(componentKey) === activeDecorVariant;
        }) ||
        null;

      if (!targetComponent) {
        console.warn('[Metabox-MW] Marquis platform toggle target not found for active component', {
          componentAction: actionContext.rule && actionContext.rule.componentAction,
          desiredPlatformState,
          activeComponent: activeComponentKey,
          targetComponent: targetComponentKey,
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      return { handled: true, component: targetComponent };
    }

    function executeKeepComponent(actionContext) {
      const slotLabel = actionContext.rule && actionContext.rule.slotNameRaw;
      const materialLabel = actionContext.rule && actionContext.rule.materialNameRaw;

      if (!slotLabel || !materialLabel) {
        console.warn('[Metabox-MW] Keep component action requires slot/material', {
          componentAction: actionContext.rule && actionContext.rule.componentAction,
          slotName: slotLabel || null,
          materialName: materialLabel || null,
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      return {
        handled: true,
        success: actionContext.applyMaterialToActiveSlot(slotLabel, materialLabel),
      };
    }

    function executeKeepMidCenturyHeight(actionContext) {
      const activeLeg = getActiveLegComponent(actionContext);
      const height = getLegHeight(activeLeg);

      const targetComponent = height
        ? findMidCenturyLegComponent(actionContext, height)
        : findFirstMidCenturyLegComponent(actionContext);
      if (!targetComponent) {
        console.warn('[Metabox-MW] Keep mid-century height action target not found', {
          height: height || null,
          activeComponent: activeLeg ? getComponentName(activeLeg) : null,
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      return { handled: true, component: targetComponent };
    }

    function getActiveLegComponent(actionContext) {
      const activeComponents = actionContext.helpers.getActiveComponents();
      return (
        activeComponents.find((component) => isLegComponent(actionContext, component)) ||
        activeComponents.find((component) => /\bleg\b/i.test(getComponentName(component))) ||
        null
      );
    }

    function findMidCenturyLegComponent(actionContext, height) {
      const targetName = `${height} mid century leg`;
      const targetNameNorm = actionContext.helpers.normalizeEntityName(targetName);
      const components = actionContext.helpers.getConfiguratorComponents().filter((component) => isLegComponent(actionContext, component));

      return (
        components.find((component) => actionContext.helpers.normalizeEntityName(getComponentName(component)) === targetNameNorm) ||
        components.find((component) => {
          const componentName = getComponentName(component);
          const normalizedName = actionContext.helpers.normalizeEntityName(componentName);
          return normalizedName.includes(`${height} mid century`) && normalizedName.includes('leg');
        }) ||
        null
      );
    }

    function findFirstMidCenturyLegComponent(actionContext) {
      return (
        actionContext.helpers
          .getConfiguratorComponents()
          .filter((component) => isLegComponent(actionContext, component))
          .find((component) => {
            const normalizedName = actionContext.helpers.normalizeEntityName(getComponentName(component));
            return normalizedName.includes('mid century') && normalizedName.includes('leg');
          }) || null
      );
    }

    function isLegComponent(actionContext, component) {
      if (!component) return false;
      const componentTypeName = component.componentType && component.componentType.name;
      if (actionContext.helpers.normalizeEntityName(componentTypeName) === 'legs') return true;
      return /\bleg\b/i.test(getComponentName(component));
    }

    function getLegHeight(component) {
      const match = getComponentName(component).match(/\b(6|12)\b/);
      return match ? match[1] : '';
    }

    function getComponentName(component) {
      return (component && component.name) || '';
    }

    function resolveDimmerBasePlateMaterialLabel(actionContext) {
      const optionLabelCabinetBody = 'Cabinet Body';
      const optionLabelLowerCabinetBody = 'Lower Cabinet Body';
      const optionLabelDimmerKnob = 'Dimmer Knob';
      const bodyLabel =
        actionContext.getSelectedOptionLabel(optionLabelCabinetBody) ||
        actionContext.getSelectedOptionLabel(optionLabelLowerCabinetBody);
      const knobLabel = actionContext.getSelectedOptionLabel(optionLabelDimmerKnob);
      const normalizedBodyLabel = actionContext.helpers.normalizeEntityName(bodyLabel);

      if (!normalizedBodyLabel) {
        return {
          bodyLabel,
          knobLabel,
          materialLabel: '',
        };
      }

      return {
        bodyLabel,
        knobLabel,
        materialLabel:
          normalizedBodyLabel === 'white' || normalizedBodyLabel === 'charcoal'
            ? actionContext.helpers.asString(knobLabel)
            : actionContext.helpers.asString(bodyLabel),
      };
    }

    function executeSyncDimmerBasePlate(actionContext) {
      const slotLabelDimmerBasePlate = 'Dimmer Base Plate';
      const resolvedLabels = resolveDimmerBasePlateMaterialLabel(actionContext);

      if (!resolvedLabels.materialLabel) {
        console.warn('[Metabox-MW] Dimmer base plate sync skipped: target material label missing', {
          bodyLabel: resolvedLabels.bodyLabel,
          knobLabel: resolvedLabels.knobLabel,
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      const changed = actionContext.applyMaterialToActiveSlot(slotLabelDimmerBasePlate, resolvedLabels.materialLabel);
      if (!changed) {
        return {
          handled: true,
          success: false,
        };
      }

      return {
        handled: true,
        success: true,
      };
    }

    function resolveIsolationTopMaterialLabel(actionContext) {
      const optionLabelDrawerFace = 'Drawer Face & Isolation Top';
      const materialLabel = actionContext.getSelectedOptionLabel(optionLabelDrawerFace);

      return {
        optionLabelDrawerFace,
        materialLabel: actionContext.helpers.asString(materialLabel),
      };
    }

    function executeSyncIsolationTopToDrawerFace(actionContext) {
      const slotLabelIsolationTop = 'Isolation Top';
      const resolvedLabels = resolveIsolationTopMaterialLabel(actionContext);

      if (!resolvedLabels.materialLabel) {
        console.warn('[Metabox-MW] Isolation top sync skipped: target material label missing', {
          optionLabel: resolvedLabels.optionLabelDrawerFace,
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      const changed = actionContext.applyMaterialToActiveSlot(slotLabelIsolationTop, resolvedLabels.materialLabel);
      if (!changed) {
        return {
          handled: true,
          success: false,
        };
      }

      return {
        handled: true,
        success: true,
      };
    }

    function resolveSaengerDrawerBoxesMaterialLabel(actionContext) {
      const optionLabelCabinetBody = 'Cabinet Body';
      const slotLabelCabinetBody = 'Cabinet Body';
      const selectedBodyLabel = actionContext.getSelectedOptionLabel(optionLabelCabinetBody);
      const bodySlot = actionContext.findActiveSlotByLabel(slotLabelCabinetBody);
      const bodyLabel = selectedBodyLabel || getCurrentActiveSlotMaterialLabel(bodySlot, actionContext.helpers);
      const normalizedBodyLabel = actionContext.helpers.normalizeEntityName(bodyLabel);
      const isBlackBody =
        normalizedBodyLabel === 'black' ||
        normalizedBodyLabel === 'ebony oak' ||
        normalizedBodyLabel.includes('black') ||
        normalizedBodyLabel.includes('ebony');

      return {
        bodyLabel,
        materialLabel: isBlackBody ? 'Ebony_Oak' : normalizedBodyLabel ? 'Maple' : '',
      };
    }

    function executeSyncSaengerDrawerBoxes(actionContext) {
      const slotLabelDrawerBoxes = 'Drawer Boxes';
      const resolvedLabels = resolveSaengerDrawerBoxesMaterialLabel(actionContext);

      if (!resolvedLabels.materialLabel) {
        console.warn('[Metabox-MW] Saenger drawer boxes sync skipped: target material label missing', {
          bodyLabel: resolvedLabels.bodyLabel,
          context: actionContext.eventContext,
        });
        return { handled: true, success: false };
      }

      const changed = actionContext.applyMaterialToActiveSlot(slotLabelDrawerBoxes, resolvedLabels.materialLabel);
      if (!changed) {
        return {
          handled: true,
          success: false,
        };
      }

      return {
        handled: true,
        success: true,
      };
    }

    async function execute(actionName, payload) {
      const actionDefinition = getActionDefinition(actionName);
      if (!actionDefinition || typeof actionDefinition.execute !== 'function') {
        return { handled: false };
      }

      return actionDefinition.execute(createActionContext(payload));
    }

    window.metaboxMwCustomActions = {
      createContext: createActionContext,
      normalizeAction,
      execute,
    };
  })();
